import { render, staticRenderFns } from "./FichasConsumo.vue?vue&type=template&id=53dcfdbb&scoped=true"
import script from "./FichasConsumo.vue?vue&type=script&lang=js"
export * from "./FichasConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcfdbb",
  null
  
)

export default component.exports